import React from 'react';
import { FileText, Shield, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const LegalLicensing = () => {
  return (
    <div className="space-y-6">
      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <FileText className="w-5 h-5" />
            Terms & Agreements
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-3 bg-gray-700 rounded-lg">
            <div>
              <h4 className="text-white font-medium">Terms of Service</h4>
              <p className="text-gray-400 text-sm">Last updated: January 2024</p>
            </div>
            <Badge className="bg-green-600">Accepted</Badge>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-700 rounded-lg">
            <div>
              <h4 className="text-white font-medium">Privacy Policy</h4>
              <p className="text-gray-400 text-sm">Last updated: January 2024</p>
            </div>
            <Badge className="bg-green-600">Accepted</Badge>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Shield className="w-5 h-5" />
            Content Ownership
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bg-blue-900/20 border border-blue-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-blue-400 mt-1" />
              <div>
                <h4 className="text-blue-400 font-medium mb-2">Content Declaration</h4>
                <p className="text-gray-300 text-sm">
                  By uploading content to I Got Soul, you declare that you own all rights to the content 
                  or have proper authorization to distribute it.
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LegalLicensing;
